import {OperatorEnum} from '../enums';

export class AttributeCriteriaDto {
  id: number;
  operator: OperatorEnum;
  attributes: {[id: number]: string};
}
